import { socialIdentityTypeEnum, partyTypeEnum } from '@/helpers/enum';
import api from './api';
import globalStore from '@/store/index';
import local from '@/local/ar';
const namespace = 'GlobalModule';
const store = (customNameSpace) => {
  return {
    state: globalStore.state[customNameSpace || namespace],
    getters: Object.keys(globalStore.getters)
      .reduce((obj, key) => {
        if (key.includes(customNameSpace || namespace + '/')) { obj[key.replace(customNameSpace || namespace + '/', '')] = globalStore.getters[key]; }
        return obj;
      }, {}),
    dispatch: (actionName, payload) =>
      globalStore.dispatch(`${customNameSpace || namespace}/${actionName}`, payload),
  };
};

export default {
  checkMOIPersonalInfo(payload) {
    return api.getMOIPersonalInfo(payload.socialId, payload.dateOfBirth)
      .then((person) => {
        const personObj = {
          familyName: person.data.familyName,
          fatherName: person.data.fatherName,
          firstName: person.data.firstName,
          grandFatherName: person.data.gfName,
          thirdName: person.data.gfName,
          nationalityCountryId: person.data.nationalityCountryId,
          nationality: person.data.nationalityCountryId,
          isRetrievedFromMoi: true,
          socialIdExpiryDate: person.data.socialIdExpiryDate,
          isSocialIdExpired: person.data.isSocialIdExpired,
          sex: person.data.genderId,
          gender: person.data.genderId,
          lifeStatusId: person.data.lifeStatusId,
          nationalAddress: { isRetrieved: false },
        };
        return personObj;
      });
  },
  checkMOIPersonalInfoByFirstName(payload) {
    return api.getMOIPersonalInfoByFirstName(payload.socialId, payload.firstName)
      .then((person) => {
        const personObj = {
          socialId: payload.socialId,
          partyType: partyTypeEnum.person,
          familyName: person.data.familyName,
          fatherName: person.data.fatherName,
          firstName: person.data.firstName,
          grandFatherName: person.data.grandFatherName,
          thirdName: person.data.grandFatherName,
          isRetrievedFromMoi: true,
          socialIdExpiryDate: null,
          isSocialIdExpired: null,
          sex: null,
          lifeStatusId: person.data.lifeStatusId,
          nationalAddress: { isRetrieved: false },
        };
        return personObj;
      });
  },
  checkCommercialRegistrationNumber(payload) {
    const companyInfoRequest = api
      .getCompanyManager(payload.commercialRegistrationNumber, payload.socialId, payload?.partyType)
      .then(manager => ({
        commercialRegistrationNumber: manager.data.commercialNumber,
        unifiedNumber: manager.data.unifiedNumber,
        name: manager.data.organizationName,
        organizationName: manager.data.organizationName,
        firstName: manager.data.firstName,
        fatherName: manager.data.secondName,
        grandFatherName: manager.data.thirdName,
        familyName: manager.data.lastName,
        managerFullName: manager.data.fullManagerName,
        socialId: manager.data.socialId,
        dateOfBirth: manager.data.dateOfBirth,
        managerIdentityNumber: manager.data.socialId,
        nationalityCountryId: manager.data.socialIdType === socialIdentityTypeEnum.nationalId ? 1 : manager.data.nationalityId,
        socialIdType: manager.data.socialIdType,
        isRetrievedFromMci: !!manager.data.organizationName && !!manager.data.firstName,
        activity: manager.data.organizationActivity,
        commercialRegistrationTypeId: manager.data.commercialRegistrationTypeId,
        statusId: manager.data.statusId,
        status: manager.status,
        mainCRUnifiedNumber: manager.data.mainCRUnifiedNumber,
        mainCRNumber: manager.data.mainCRNumber,
      }))
      .catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 400)
          return api.getCompanyInfo(payload.commercialRegistrationNumber)
            .then(company => ({
              commercialRegistrationNumber: company.data.commercialRegisterNumber,
              unifiedNumber: company.data.unifiedNumber,
              name: company.data.name,
              organizationName: company.data.name,
              activity: company.data.activity,
              isRetrievedFromMci: false,
            }));
        else
          return error;
      });
    return companyInfoRequest.then((companyInfo) => {
      if ((companyInfo.status == 200 || !payload?.partyType) && (companyInfo.socialId === store().getters['socialId'] || !!payload.allowAddressCheck))
        return api
          .getCompanyAddress(payload.commercialRegistrationNumber)
          .then(address => ({
            ...companyInfo,
            nationalAddress: {
              city: address.data.city,
              cityId: address.data.cityId,
              district: address.data.district,
              districtId: address.data.districtId,
              street: address.data.street,
              postalCode: address.data.postCode,
              poBox: address.data.additionalNumber,
              buildingNumber: address.data.buildingNumber,
              regionName: address.data.regionName,
              cityNameEnglish: address.data.cityNameEnglish,
              isRetrieved: !!address.data.cityNameEnglish,
            },
          }))
          .catch(() => ({
            ...companyInfo,
            nationalAddress: { isRetrieved: false },
          }));
      else
        return {
          ...companyInfo,
          nationalAddress: { isRetrieved: false },
        };
    });
  },
  async checkPersonalAddress(socialId) {
    const currentUserSocialId = store('GlobalModule').getters['/socialId'];
    await store('LookupsModule').dispatch('getCities');
    const cities = store('LookupsModule').state.cities;
    return api
      .getPersonalAddress(socialId)
      .then((addresses) => {
        const nationalAddresses = addresses.data.map((address, id) => ({
          ...address,
          id,
          text: getAddressText(address, socialId, currentUserSocialId, cities),
        })).filter(a => !!a.text).map((filteredAddress, id) => ({
          ...filteredAddress,
          id: id,
        }));
        return {
          nationalAddresses,
          nationalAddress: nationalAddresses.length > 1 ? { isRetrieved: false } : {
            id: 0,
            city: nationalAddresses[0].city,
            cityId: nationalAddresses[0].cityId,
            district: nationalAddresses[0].district,
            districtId: nationalAddresses[0].districtId,
            street: nationalAddresses[0].street,
            postalCode: nationalAddresses[0].postCode,
            poBox: nationalAddresses[0].additionalNumber,
            buildingNumber: nationalAddresses[0].buildingNumber,
            regionName: nationalAddresses[0].regionName,
            cityNameEnglish: nationalAddresses[0].cityNameEnglish,
            isRetrieved: !!nationalAddresses[0].cityNameEnglish,
          },
        };
      })
      .catch(() => {
        return { nationalAddress: {} };
      });
  },

  async getPrisonerCriminalRecord(payload) {
    if (!payload.socialId || !payload.dateOfBirth) {
      return;
    }
    try {
      const prisoner = await api.getPrisonerCriminalRecord(payload.socialId, payload.dateOfBirth);
      const prisonerObj = {
        isPrisoner: prisoner.data.isPrisoner,
        isRetrievedFromPrisons: true,
      };

      if (prisoner.data.data) {
        prisonerObj.caseNumber = prisoner.data.data.caseNumber;
        prisonerObj.prisonerNo = prisoner.data.data.jailCode;
        prisonerObj.prisonName = prisoner.data.data.jailName;
        prisonerObj.prisonCityId = prisoner.data.data.cityId;
      }

      return prisonerObj;
    } catch (error) {
      // eslint-disable-next-line no-empty
    }
  },
  getAttorneyDetails: payload => api.getAttorneyDetails(payload)
    .then(mapAttorneyDetails),
  validateAgentAttorney: payload => api.validateAttorneyExistence(payload)
    .then(mapAttorneyDetails),
  validateAgentAttorneyIncludeExternal: payload => api.validateAttorneyExistenceIncludeExternal(payload)
    .then(mapAttorneyDetails),
};

const attorneyPartyMapper = p => ({
  socialIdType: p.identityTypeId,
  socialId: p.identityNo,
  fullName: p.fullName,
  firstName: p.firstName,
  fatherName: p.fatherName,
  grandFatherName: p.grandFatherName,
  familyName: p.familyName,
  dateOfBirth: p.dateOfBirth,
  nationalityCountryId: p.nationalityId,
  sex: p.genderId,
  isRetrievedFromMoi: true,
  contact: {},
  nationalAddress: {},
});

const mapAttorneyDetails = details => ({
  attorneyNumber: details.data.code,
  attorneyTypeId: details.data.attorneyType,
  attorneyText: details.data.attorneyText,
  attorneyTypeName: details.data.attorneyTypeName,
  attorneyPlaceName: details.data.attorneyPlaceName,
  firstParties: details.data.firstParties
    .filter((value, index, array) => array.findIndex(mp => mp.identityNo === value.identityNo) === index)
    .map(attorneyPartyMapper),
  secondParties: details.data.secondParties
    .filter((value, index, array) => array.findIndex(mp => mp.identityNo === value.identityNo) === index)
    .map(attorneyPartyMapper),
  isApprovedFromMofa: details.data.isApprovedFromMofa,
  isApprovedFromMoj: true,
  kharjiaCountry: details.data.kharjiaCountry,
  binary: details.data.binary,
  isVerified: true,
});
const getAddressText = (item, partySocialId, currentUserSocialId, cities) => {
  let address = [];
  const city = item.cityNameEnglish && (cities || []).
    find(c => (c.nationalAddressCityEnglishName || '').split(',')
      .some(n => n === item.cityNameEnglish)) || {};
  if (city.name) address.push(city.name);
  if (partySocialId === currentUserSocialId) {
    if (item.street) address.push(local.nationalAddress.str + ' ' + item.street);
    if (item.buildingNumber) address.push(local.nationalAddress.buildingNum + ' ' + item.buildingNumber);
  }
  return address.join('، ');
};